import { _userLevel } from 'ecp/models/UsersModel'
import { _tableAreas } from 'globals'

// Piloto da #7471: a lista de usuários fica no servidor, que devolve `isCommercialPilot` no login
export interface IPilotUser {
  level?: _userLevel
  areaName?: _tableAreas
  isCommercialPilot?: boolean
}

const PilotUsersModel = {
  isPilotCommercial (user: IPilotUser): boolean {
    return user.level === 'commercial' && user.isCommercialPilot === true
  },

  isPilotCommercialAdministrator (user: IPilotUser): boolean {
    const isCommercialAdministrator = user.level === 'administrator' && user.areaName === 'comercial'
    return isCommercialAdministrator && user.isCommercialPilot === true
  }
}

export default PilotUsersModel
